import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { history } from '../store'
import * as dateFormat from 'dateformat'

import { deleteSale } from '../actions/sales'

class SaleList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deleting: false,
      deleteConfirmShown: false,
      deleteId: null,
      currentPage: 1,
      todosPerPage: 100,
      maxPageLimit: 10,
      minPageLimit: 0,
      

    };

    this.delete = this.delete.bind(this)
    this.deleteConfirmShow = this.deleteConfirmShow.bind(this)
    this.deleteConfirmToggle = this.deleteConfirmToggle.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.onPrevClick = this.onPrevClick.bind(this)
    this.onNextClick = this.onNextClick.bind(this)
    this.renderPageNumbersFunc = this.renderPageNumbersFunc.bind(this)
  }

  handleClick(event) {
    const { currentPage, maxPageLimit, minPageLimit } = this.state;

    this.setState({
      currentPage: Number(event.target.id)
    });

    this.renderPageNumbersFunc();

  }

  onPrevClick(event) {
    const { currentPage, maxPageLimit, minPageLimit } = this.state;

    if (minPageLimit === 0) {
      this.setState({
        currentPage: currentPage - 1
      });
    } else {
      this.setState({
        currentPage: currentPage - 1,
        maxPageLimit: maxPageLimit - 1,
        minPageLimit: minPageLimit - 1
      });
    }

    this.renderPageNumbersFunc();

  }

  onNextClick(event) {
    const { currentPage, maxPageLimit, minPageLimit, todosPerPage } = this.state;
    const totalPages = Math.ceil((this.props.sales.sales && this.props.sales.sales.length) / todosPerPage) || 1;

    if (maxPageLimit === totalPages) {
      this.setState({
        currentPage: currentPage + 1
      });
    } else {
      this.setState({
        currentPage: currentPage + 1,
        maxPageLimit: maxPageLimit + 1,
        minPageLimit: minPageLimit + 1
      });
    }


    this.renderPageNumbersFunc();
  }

  goTo(id, e) {
    history.push(`/sales/${id}`)
  }

  delete() {
    const { deleteSale } = this.props

    this.setState({ deleting: true })
    deleteSale(this.state.deleteId)
  }

  deleteConfirmShow(id) {
    this.setState({
      deleteConfirmShown: true,
      deleteId: id
    })
  }

  deleteConfirmToggle() {
    this.setState({ deleteConfirmShown: !this.state.deleteConfirmShown })
  }

  componentDidMount() {
    const { maxPageLimit } = this.state;
    const totalPages = Math.ceil((this.props.sales.sales && this.props.sales.sales.length) / this.state.todosPerPage) || 1;

    if (totalPages < maxPageLimit) {
      this.setState({ maxPageLimit: totalPages });
    }
  }

  renderPageNumbersFunc() {
    const { maxPageLimit, minPageLimit, todosPerPage, currentPage } = this.state
    const { sales } = this.props

    const totalPages = Math.ceil((sales.sales && sales.sales.length) / todosPerPage) || 1
    const pagesArray = [];
    for (let i = 1; i <= totalPages; i++) pagesArray.push(i)

    return pagesArray.slice(Number(minPageLimit), Number(maxPageLimit)).map(number => (
      <li
        key={number}
        id={number}
        onClick={this.handleClick}
        className={(this.state.currentPage === number ? 'active ' : '') + 'controls'}
      >
        {number}
      </li>
    ));
  }

  renderLockerID(sale) {

    let tumbonas = false;

    for (let item of sale.Items) {
      if (item.item === "TUMBONAS") {
        tumbonas = true;
      }
    }

    if (tumbonas) {
      return (<div className="lockerIDTUMBONAS">TUMBONA</div>)
    } else {
      return (<div className="lockerID">{sale.Locker}</div>)
    }

  }

  render() {
    const { auth, sales, maxPageLimit, minPageLimit, role } = this.props

    const { currentPage, todosPerPage } = this.state

    const totalPages = Math.ceil((sales.sales && sales.sales.length) / todosPerPage) || 1
    const pagesArray = [];
    for (let i = 1; i <= totalPages; i++) pagesArray.push(i)

    // Logic for displaying current sales
    const indexOfLastTodo = currentPage * todosPerPage;
    const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
    const currentTodos = sales.sales.slice(indexOfFirstTodo, indexOfLastTodo);

    const renderTodos = currentTodos.map((sale, index) => {
      return (
        <tr key={index}>
          <th scope="row">{sale.Code}</th>
          <td>{sale.Customer.Fullname}</td>
          <td>{sale.PaymentMethod == 'TOKEN' ? (sale.Amount >= 0 ? "MANUAL" : "DEVOLUCIÓN") : sale.PaymentMethod}</td>
          <td>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <small className="text-muted">Pago:</small>
              <div>{sale.TimeStamp ? (new Date(sale.TimeStamp)).toLocaleString('es-ES', { timeZone: 'Europe/Madrid' }) : ''}</div>
              <small className="text-muted">Subida:</small>
              <div>{sale.createdAt ? (() => { const d = new Date(sale.createdAt); d.setHours(d.getHours() - 1); return d.toLocaleString('es-ES', { timeZone: 'Europe/Madrid' }); })() : ''}</div>
            </div>
          </td>
          <td>{`${parseFloat(sale.Amount).toLocaleString("es-ES", { style: "currency", currency: "EUR" })}`}</td>
          <td>{sale.Language.toUpperCase()}</td>
          <td>{this.renderLockerID(sale)}</td>
          <td>
            {(() => {
              const totalSeconds = sale.OperationTime || 0;
              const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
              const seconds = String(totalSeconds % 60).padStart(2, '0');
              return `${minutes}:${seconds}`;
            })()}
          </td>
          <td>
            <button className="btn btn-primary mr-1" onClick={() => openInNewTab(`/sales/${sale._id}`)}>
              <i className="fas fa-info mr-1"></i>Detalles
            </button>
          </td>
          {/* {role === 'ADMIN' &&
            <td>
              <button className="btn btn-danger mr-1" onClick={() => this.deleteConfirmShow(sale._id)}>
                <i className="fas fa-trash mr-1"></i>
              </button>
            </td>
          } */}
        </tr>
      );
    });

    const openInNewTab = url => {
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
      <div className="table-responsive">
        <h4 style={{ textAlign: 'center' }}>Página {currentPage} de {pagesArray[pagesArray.length - 1] || 1}</h4>
        <ul id="page-numbers">
          <button className="btn btn-primary mr-1" onClick={this.onPrevClick} disabled={currentPage === pagesArray[0]}>Prev</button>

          {this.renderPageNumbersFunc()}

          <button className="btn btn-primary mr-1" onClick={this.onNextClick} disabled={currentPage === pagesArray[pagesArray.length - 1]}>Next</button>
        </ul>
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Factura</th>
              <th scope="col">Cliente</th>
              <th scope="col">Pago</th>
              <th scope="col">Fecha/Hora</th>
              <th scope="col">Importe</th>
              <th scope="col">Idioma</th>
              <th scope="col">Locker</th>
              <th scope="col">Tiempo</th>
              <th scope="col"></th>
              {/* {role === 'ADMIN' &&
                <th scope="col"></th>
              } */}
            </tr>
          </thead>
          <tbody>
            {renderTodos}
          </tbody>
        </table>
        <ul id="page-numbers">
          <button className="btn btn-primary mr-1" onClick={this.onPrevClick} disabled={currentPage === pagesArray[0]}>Prev</button>

          {this.renderPageNumbersFunc()}

          <button className="btn btn-primary mr-1" onClick={this.onNextClick} disabled={currentPage === pagesArray[pagesArray.length - 1]}>Next</button>
        </ul>
        <h4 style={{ textAlign: 'center' }}>Página {currentPage} de {pagesArray[pagesArray.length - 1] || 1}</h4>
        {/* Confirm deletion */}
        <div>
          <Modal isOpen={this.state.deleteConfirmShown}
            toggle={this.deleteConfirmToggle}>
            <ModalHeader toggle={this.deleteConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de borrar la venta?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="primary mr-1" onClick={this.delete}>
                Borrar
              </Button>
              <Button color="secondary" onClick={this.deleteConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  sales: state.sales,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  deleteSale: bindActionCreators(deleteSale, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SaleList)


